import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["allowedMessageChannelIds", "isSelected", "selectChannel", "currentDrafts"];
import { List } from 'foundations-components/transitional/components/List';
import { ChannelLabel } from '../../../capability-editor/public/components';
import { CallingTab } from './CallingTab';
import { useAsyncGenericChannelsWithCapabilities } from 'composer-data/channel-capabilities/public/hooks';
import { Flex } from 'foundations-components/components/Flex';
import { EditIcon } from 'foundations-assets';
import { Button } from 'foundations-components/transitional/components/Button';
import { Box } from 'foundations-components/transitional/components/Box';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ChannelDropdownOption = ({
  selectChannel,
  isSelected,
  genericChannelId,
  hasDraft
}) => {
  const {
    loading,
    error
  } = useAsyncGenericChannelsWithCapabilities();
  const disabled = Boolean(loading || error);
  return /*#__PURE__*/_jsx(Button, {
    use: "primary-white",
    disabled: disabled,
    onClick: selectChannel,
    value: genericChannelId,
    "data-test-id": "channel-switch-dropdown-option",
    "data-channel-id": genericChannelId,
    "is-selected": `${isSelected}`,
    children: /*#__PURE__*/_jsx(Flex, {
      inlineSize: "100%",
      justifyContent: "start",
      children: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "start",
        inlineSize: "100%",
        children: [/*#__PURE__*/_jsx(ChannelLabel, {
          genericChannelId: genericChannelId
        }), hasDraft && /*#__PURE__*/_jsx(Box, {
          marginInlineStart: "200",
          children: /*#__PURE__*/_jsx(EditIcon, {
            size: "100",
            color: "icon-core-subtle",
            "data-test-id": "edit-icon"
          })
        })]
      })
    })
  });
};
ChannelDropdownOption.displayName = 'ChannelDropdownOption';
function hasCalling(props) {
  return props.hasCalling;
}
export const ChannelDropdownOptions = _ref => {
  let {
      allowedMessageChannelIds,
      isSelected,
      selectChannel,
      currentDrafts
    } = _ref,
    callingProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const shouldIncludeCalling = hasCalling(callingProps);
  return /*#__PURE__*/_jsxs(List, {
    wrapChildren: true,
    children: [shouldIncludeCalling ? /*#__PURE__*/_jsx(CallingTab, Object.assign({}, callingProps)) : null, allowedMessageChannelIds.map(channelId => {
      return /*#__PURE__*/_jsx(ChannelDropdownOption, {
        genericChannelId: channelId,
        isSelected: isSelected,
        selectChannel: selectChannel,
        hasDraft: !!(currentDrafts !== null && currentDrafts !== void 0 && currentDrafts.getDrafts.drafts.find(d => d.genericChannelId === channelId))
      }, channelId);
    })]
  });
};
ChannelDropdownOptions.displayName = 'ChannelDropdownOptions';